<template>
  <div class="c-safeguard">
    <v-container class="app-bg">
      <v-layout v-if="value" column justify-center class="mt-3">
        <v-flex v-for="(item,index) in value.safeguards" :key="index" class="mb-5">
          <v-layout column align-center justify-center>
            <h2>{{ item.title }}</h2>
            <p class="subheading">{{ item.content }}</p>
            <img class="responsive-img my-3" :src="item.img">
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <Company v-if="product" :value="product.company" class="mt-3"></Company>
  </div>
</template>

<script>
import Company from "./Company";
export default {
  components: {
    Company
  },
  props: {
    value: Object,
    product: Object
  }
};
</script>

